import React from 'react';

/** Uses the same heading pattern as other pages: Bootstrap h6 + text-success. */
export default function DiagnosticsSectionHeader({ children }) {
  return <h6 className="text-success text-center">{children}</h6>;
}
